import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleDrive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1497_28760)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6.31586 37.3653C6.94744 37.7162 7.61411 37.8917 8.31586 37.8917H31.6843C32.3159 37.8917 32.9825 37.7162 33.6843 37.3653V26.418H3.47375",
				fill: "#4285F4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.6842 2.62788C14.3158 2.277 15.0175 2.10156 15.7895 2.10156H24.2105C25.0526 2.10156 25.7544 2.277 26.3158 2.62788V13.5752H19.1579",
				fill: "#188038"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 26.4184C0 25.7166 0.175439 25.05 0.526316 24.4184L12.1053 4.31312C12.5263 3.54119 13.0526 2.97978 13.6842 2.62891L20 13.5763L12.4211 26.7342",
				fill: "#34A853"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20 13.5763L27.5789 26.7342L40 26.4184C40 25.5763 39.7193 24.7342 39.1579 23.8921L27.8947 4.31312C27.5439 3.61136 27.0175 3.04996 26.3158 2.62891",
				fill: "#FBBC04"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.6015 26.418H0C0 26.9794 0.105263 27.5057 0.315789 27.9969L4.52632 35.3653C5.01754 36.2776 5.61404 36.9443 6.31579 37.3653",
				fill: "#1967D2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M33.6842 37.3653C34.3158 37.0145 34.8772 36.418 35.3684 35.5759L39.3684 28.6285C39.7895 27.9267 40 27.1899 40 26.418H27.4",
				fill: "#EA4335"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1497_28760",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "white"
		})
	}) })]
});
export default SvgGoogleDrive;
